var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdPlungeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.893 12.271.564.677c.51.611 1.38.777 2.078.396A1.667 1.667 0 0 1 23 14.807V21a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6.193a1.667 1.667 0 0 1 2.465-1.463 1.667 1.667 0 0 0 2.078-.396l.564-.677a2.7 2.7 0 0 1 3.984-.18 2.7 2.7 0 0 0 3.818 0 2.7 2.7 0 0 1 3.984.18Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23 17-1.707.931a2.725 2.725 0 0 1-3.393-.652v0a2.708 2.708 0 0 0-3.99-.188v0a2.7 2.7 0 0 1-3.82 0v0a2.708 2.708 0 0 0-3.99.188v0a2.725 2.725 0 0 1-3.393.652L1 17",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8v13a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V8m-8.402-5.5L9.4 5.5m.002-3 5.197 3M12 1v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdPlungeActive);
export default __webpack_public_path__ + "static/media/cold-plunge-active.39693f6e2105333c605c9300a13013b0.svg";
export { ForwardRef as ReactComponent };